<app-pdf-url-row class="form-list-row">
  <h5 class="row-title" >{{formEntry().formNumber}}</h5>
  <p class="row-description">{{formEntry().title}}</p>

  <div class="row-buttons">
    <a href="{{formEntry().fileUrl}}" type="button" class="btn btn-primary button-form-row-action" aria-label="Download {{formEntry().formNumber}}-Form" target="_blank">Download</a><!--&nbsp;-->

    @if (apiService.isAds820(formEntry())) {
      <a type="button" class="btn btn-primary button-form-row-action" aria-label="Submit {{formEntry().formNumber}}-Form online" style="text-transform: uppercase;" href="/contact/assessor/3">Submit Online</a><!--&nbsp;-->
    } @else if (formEntry().hasEFile) {
      <a type="button"
         class="btn btn-primary button-form-row-action"
         [href]="formEntry().eFileMaintenance ? null : apiService.getEFileUrl(formEntry().formNumber)"
         aria-label="Submit {{formEntry().formNumber}}-Form online"
         style="text-transform: uppercase;"
         [ngbTooltip]="siteConfigService.getEFileMaintenanceAlert() ?? formEntry().eFileMaintenance ? formEntry().eFileMaintenanceBanner ?? '' : ''"
         [class.tooltip-disabled]="formEntry().eFileMaintenance || siteConfigService.isEFileDisabled()"
         [class.disabled]="formEntry().eFileMaintenance || siteConfigService.isEFileDisabled()"
         (click)="handleEFilePreClick($event)">Submit Online</a><!--&nbsp;-->
    }

    @if (formEntry().instructionUrl) {
      <a target="_blank" class="btn btn-primary button-form-row-action" [href]="formEntry().instructionUrl" type="button" aria-label="View E-FILE INSTRUCTIONS for {{formEntry().formNumber}}" style="text-transform: uppercase;">E-FILE INSTRUCTIONS</a>
    }
  </div>
</app-pdf-url-row>
